// Объявляем переменные в области видимости модуля
let lastAnsweredCard = null;
let cards = [];
let cardsContainer = null;
let resultContainer = null;
let currentQuestion = null;
let totalQuestions = null;

// Функция для инициализации позиций карточек (вынесена отдельно)
function initCardPositions() {
  const activeCards = cards.filter(
    (card) =>
      !card.classList.contains("history-quiz__card--done") &&
      !card.classList.contains("history-quiz__card--answered")
  );

  activeCards.forEach((card, index) => {
    card.style.transform = "";
    card.style.left = `${index * 40}px`;
    card.style.top = `${index * 40}px`;
    card.style.zIndex = `${20 - index}`;
  });

  if (activeCards.length > 0) {
    cards.forEach((card) =>
      card.classList.remove("history-quiz__card--active")
    );
    activeCards[0].classList.add("history-quiz__card--active");
  }

  if (currentQuestion) {
    const doneCards = cards.filter((card) =>
      card.classList.contains("history-quiz__card--done")
    ).length;
    currentQuestion.textContent = doneCards + 1;
  }
}

// Функция ручного переключения слайдов (вынесена наружу)
function nextQuizCard() {
  // Если нет отвеченной карточки, находим активную
  if (!lastAnsweredCard) {
    const activeCard = cards.find(
      (card) =>
        card.classList.contains("history-quiz__card--active") &&
        !card.classList.contains("history-quiz__card--done") &&
        !card.classList.contains("history-quiz__card--answered")
    );

    if (activeCard) {
      activeCard.classList.remove("history-quiz__card--active");
      activeCard.classList.add("history-quiz__card--answered");
      lastAnsweredCard = activeCard;
    }
  }

  // Если после проверок lastAnsweredCard все еще null - выходим
  if (!lastAnsweredCard) return;

  lastAnsweredCard.classList.add("history-quiz__card--done");
  lastAnsweredCard.classList.remove("history-quiz__card--answered");

  lastAnsweredCard.style.transform = "translateX(100px) rotate(5deg)";
  lastAnsweredCard.style.opacity = "0";
  lastAnsweredCard.style.transition = "all 0.75s ease";

  const cardToRemove = lastAnsweredCard;
  lastAnsweredCard = null;

  const remainingCards = cards.filter(
    (card) => !card.classList.contains("history-quiz__card--done")
  );

  if (remainingCards.length === 0) {
    const event = new Event("quizCompleted");
    document.dispatchEvent(event);
    return;
  }

  setTimeout(initCardPositions, 300);
}

function initQuiz() {
  cardsContainer = document.querySelector(".history-quiz__cards");
  if (!cardsContainer) return;

  cards = Array.from(cardsContainer.querySelectorAll(".history-quiz__card"));
  resultContainer = document.getElementById("result");
  currentQuestion = document.getElementById("current");
  totalQuestions = document.getElementById("total");

  if (totalQuestions) {
    totalQuestions.textContent = cards.length;
  }

  // Обработчик отправки формы
  function handleFormSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const card = form.closest(".history-quiz__card");

    if (!card || !card.classList.contains("history-quiz__card--active")) return;

    card.classList.remove("history-quiz__card--active");
    card.classList.add("history-quiz__card--answered");
    lastAnsweredCard = card;
  }

  // Функция перезапуска
  function restartQuiz() {
    cards.forEach((card) => {
      card.classList.remove(
        "history-quiz__card--done",
        "history-quiz__card--active",
        "history-quiz__card--answered"
      );
      card.style.left = "";
      card.style.top = "";
      card.style.zIndex = "";
      card.style.opacity = "";
      card.style.transform = "";
      card.style.transition = "";

      const form = card.querySelector("form");
      if (form) form.reset();
    });

    lastAnsweredCard = null;
    if (resultContainer) resultContainer.style.display = "none";
    initCardPositions();
  }

  cardsContainer.addEventListener("submit", handleFormSubmit);
  initCardPositions();

  // Делаем функции доступными глобально
  window.nextQuizCard = nextQuizCard;
  window.restartQuiz = restartQuiz;
}

function showHistoryForm(className) {
  const form = document.querySelector(className);
  if (form) {
    form.classList.add("history-quiz__result--active");
  }
}

function hideHistoryForm(className) {
  const form = document.querySelector(className);
  if (form) form.classList.remove("history-quiz__result--active");
}

function blinkBrain(isCorrect = false) {
  const brainElement = document.querySelector(".history-quiz__brain");

  if (!brainElement) {
    return;
  }

  // Удаляем предыдущие классы цвета
  brainElement.classList.remove(
    "history-quiz__brain--green",
    "history-quiz__brain--red"
  );

  // Добавляем соответствующий класс с задержкой для срабатывания анимации
  setTimeout(() => {
    if (isCorrect) {
      brainElement.classList.add("history-quiz__brain--green");
    } else {
      brainElement.classList.add("history-quiz__brain--red");
    }
  }, 10);
}

// Обновляем экспорт
export { initQuiz, blinkBrain, showHistoryForm, hideHistoryForm, nextQuizCard };
